import styles from "./OrderSummary.module.css";
import { Link } from "react-router-dom";
import CartProduct from "../../cartProduct/CartProduct";

export function normalizeShippingAmount(value) {
    const numericValue = Number(value);

    if (!Number.isFinite(numericValue)) {
        return 0;
    }

    return numericValue;
}

export function getCheckoutAmounts(cart, shippingRate = null, taxOverride = null) {
    const subtotalCents = Number(cart?.subtotal_cents ?? 0);
    const taxCents = Number(taxOverride ?? cart?.tax_cents ?? 0);

    const subtotal = subtotalCents / 100;
    const shipping = shippingRate != null
        ? normalizeShippingAmount(shippingRate)
        : normalizeShippingAmount((cart?.shipping_cents ?? 0) / 100);
    const tax = taxCents / 100;
    const total = Number((subtotal + shipping + tax).toFixed(2));

    return { subtotal, shipping, tax, total };
}

function OrderSummary({ cart, shippingRate = null, taxCents = null }) {
    if (!cart || !cart.items || cart.items.length === 0) {
        return (
            <div className={styles.emptyCart}>
                <p>Your cart is empty.</p>
                <Link to="/home" className={styles.continueShoppingButton}>
                    Continue Shopping
                </Link>
            </div>
        );
    }

    const amounts = getCheckoutAmounts(cart, shippingRate, taxCents);

    const cartProductClasses = {
        container: styles.product,
        imageContainer: styles.productImageContainer,
        image: styles.productImage,
        imagePlaceholder: styles.productImagePlaceholder,
        info: styles.productInfo,
        header: styles.productHeader,
        details: styles.productDetails,
        name: styles.productName,
        description: styles.productMetadata,
        deleteButton: styles.hiddenControl,
        footer: styles.productFooter,
        quantityControls: styles.quantityControls,
        quantityButton: styles.hiddenControl,
        quantity: styles.productMetadata,
        price: styles.productPrice,
    };

    return (
        <div className={styles.orderSummary}>
            <div className={styles.cartProductList}>
                <ul className={styles.cartProductListScroll}>
                    {cart.items.map((item) => (
                        <CartProduct
                            key={item.id}
                            item={item}
                            cartProductClassesOverride={cartProductClasses}
                        />
                    ))}
                </ul>
            </div>
            <div className={styles.totals}>
                <div className={styles.totalRow}>
                    <span>Sub Total:</span>
                    <span>${amounts.subtotal.toFixed(2)}</span>
                </div>
                <div className={styles.totalRow}>
                    <span>Shipping:</span>
                    <span>${amounts.shipping.toFixed(2)}</span>
                </div>
                <div className={styles.totalRow}>
                    <span>Tax:</span>
                    <span>${amounts.tax.toFixed(2)}</span>
                </div>
                <div className={styles.totalRow}>
                    <span>Total:</span>
                    <span>${amounts.total.toFixed(2)}</span>
                </div>
            </div>
        </div>
    );
}

export default OrderSummary;